var content = require("!!../../../css-loader/index.js?-minimize!./image-gallery.css");
var loader = require("C:\\Users\\Nuno\\Desktop\\Source\\SPFx\\BannerWP\\node_modules\\@microsoft\\load-themed-styles\\lib\\index.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1]);

if(content.locals) module.exports = content.locals;


//////////////////
// WEBPACK FOOTER
// ./~/react-image-gallery/styles/css/image-gallery.css
// module id = 60
// module chunks = 0